export default function cloudflareLoader({
  src,
  width,
  quality,
}: {
  src: string;
  width: number;
  quality?: number;
}): string {
  // In dev there is no Cloudflare edge to resize images, so serve the original
  // file — but still encode `width` in the URL (a query param the static dev
  // server ignores) so next/image's loader-width check passes and no console
  // warning is emitted. https://nextjs.org/docs/messages/next-image-missing-loader-width
  if (process.env.NODE_ENV !== "production") return `${src}?w=${width}`;
  return `/cdn-cgi/image/width=${width},quality=${quality ?? 85},format=auto${src}`;
}
